import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { DeviceCategory } from '../../../../model/device-category';

@Component({
  selector: 'app-tenant-device-categories',
  templateUrl: './tenant-device-categories.component.html',
  styleUrls: ['./tenant-device-categories.component.scss']
})
export class TenantDeviceCategoriesComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public deviceCategories: DeviceCategory[];
  public totalDeviceCategories: number;
  public loadingDeviceCategories: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadDeviceCategories(this.first / this.rows, this.rows);
  }

  private loadDeviceCategories(offset: number, limit: number): void {
    this.loadingDeviceCategories = true;
    this.tenantsService.getTenantDeviceCategories(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.deviceCategories = response.deviceCategories.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalDeviceCategories = response.totalElements;
        this.loadingDeviceCategories = false;
      });
  }

  onPageChange(event): void {
    this.loadDeviceCategories(event.first / event.rows, event.rows);
  }

}
